import React from 'react';

import ProtectedFooterRoute, { FooterRouteProps } from './ProtectedFooterRoute';
import {
  ManagerOverviewPage,
  ManagerProjectOverviewPage,
  ManagerProjectsPage,
  ManagerReviewQueuePage,
} from '../../pages';
import { RouterPaths } from '../../constants/routes';

const ManagerRoutes: FooterRouteProps[] = [
  {
    Component: ManagerOverviewPage,
    exact: true,
    path: RouterPaths.manager,
  },
  {
    Component: ManagerProjectOverviewPage,
    exact: true,
    path: RouterPaths.managerProject,
  },
  {
    Component: ManagerProjectsPage,
    exact: true,
    path: RouterPaths.managerProjects,
  },
  {
    Component: ManagerReviewQueuePage,
    exact: true,
    path: RouterPaths.managerReview,
  },
];

const ManagerNavigator = ManagerRoutes.map((route) => (
  <ProtectedFooterRoute key={route.path} {...route} />
));

export default ManagerNavigator;
